import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import clsx from "clsx";
import { toast } from "react-toastify";
import Input from "../../common/InputField";
import ButtonMain from "../../common/ButtonMain";
import PasswordField from "../../common/passwordInput";
import { CreateUserByLinkApi } from "../../../store/features/CreateUserByLink";
import { validateInvitationGenerateApi } from "../../../store/features/validateInvitationGenerate";
import FooterTrustChat from "../../common/FooterTrustChat";
import Navbar from "../../common/Navbar";

function CreateUserFromInviteLink() {
  const [isLoading, setIsLoading] = useState(false);
  const [isValidating, setIsValidating] = useState(true);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [stateName, setStateMethod] = useState({
    email: "",
    emailInvalid: false,
    emailInvalidMessage: "",
    fullName: "",
    fullNameInvalidMessage: "",
    fullNameInvalid: false,
    FormSubmitting: false,
    nameState: false,
    emailState: false,
    firstPassword: "",
    firstPasswordInvalidError: false,
    firstPasswordInvalid: "",
    secondPassword: "",
    secondPasswordInvalidError: "",
    secondPasswordInvalid: false,
    FormSubmitting: false,
    firstPasswordState: false,
    secondPasswordState: false,
    showPassword: false,
  });

  const ValidateEmail = (email) => {
    if (validator.isEmail(email) === false) {
      return false;
    }
    return true;
  };
  const specialCharacterRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\|/`"'-]/;
  const ValidatePassword = (password) => {
    if (
      validator.isStrongPassword(password, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      return true;
    }
    return false;
  };
  const handleChange = async (event) => {
    switch (event.target.name) {
      case "email":
        const emailValue = event.target.value.toLowerCase();
        if (!ValidateEmail(emailValue)) {
          setEmail(emailValue);
          setStateMethod({
            ...stateName,
            [event.target.name]: emailValue,
            emailInvalidMessage: t.EMAILERROR,
            emailInvalid: true,
            emailState: false,
          });
        } else {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            emailInvalidMessage: "",
            emailInvalid: false,
            emailState: true,
          });
        }
        break;
      case "fullName":
        if (specialCharacterRegex.test(event.target.value)) {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            fullNameInvalidMessage: t.SPECIALCHARERROR,
            fullNameInvalid: true,
            nameState: false,
          });
        } else if (event.target.value?.length < 3) {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            fullNameInvalidMessage: t.FULLNAMEERROR,
            fullNameInvalid: true,
            nameState: false,
          });
        } else if (event.target.value?.length > 24) {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            fullNameInvalidMessage: "Full name must be less than 24 characters",
            fullNameInvalid: true,
            nameState: false,
          });
        } else {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            fullNameInvalidMessage: "",
            fullNameInvalid: false,
            nameState: true,
          });
        }
        break;
      default:
        setStateMethod({
          ...stateName,
          [event.target.name]: event.target.value,
        });
    }
  };
  const handleChangePassword = async (event) => {
    switch (event.target.name) {
      case "firstPassword":
        const newFirstPassword = event.target.value;
        let newState = {
          ...stateName,
          [event.target.name]: newFirstPassword,
        };

        if (!ValidatePassword(newFirstPassword)) {
          newState.firstPasswordInvalidError = t.PASSWORDERROR;
          newState.firstPasswordInvalid = true;
          newState.firstPasswordState = false;
        } else {
          newState.firstPasswordInvalidError = "";
          newState.firstPasswordInvalid = false;
          newState.firstPasswordState = true;
        }

        if (stateName.secondPassword) {
          if (stateName.secondPassword !== newFirstPassword) {
            newState.secondPasswordInvalidError = t.CONFIRMPASSWORDERROR;
            newState.secondPasswordInvalid = true;
            newState.secondPasswordState = false;
          } else {
            newState.secondPasswordInvalidError = " ";
            newState.secondPasswordInvalid = false;
            newState.secondPasswordState = true;
          }
        }

        setStateMethod(newState);
        break;
      case "secondPassword":
        if (event.target.value !== stateName.firstPassword) {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            secondPasswordInvalidError: t.CONFIRMPASSWORDERROR,
            secondPasswordInvalid: true,
            secondPasswordState: false,
          });
        } else {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            secondPasswordInvalidError: " ",
            secondPasswordInvalid: false,
            secondPasswordState: true,
          });
        }
        break;
      default:
        setStateMethod({
          ...stateName,
          [event.target.name]: event.target.value,
        });
    }
  };

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get("q");
    if (token) {
      dispatch(validateInvitationGenerateApi(token)).then((res) => {
        const status = res?.payload?.status;
        console.log("Validation Status:", status);

        if (status === 200) {
          setIsValidating(false);
        } else if (status === 410) {
          navigate("/link-expired");
        } else if (status === 400) {
          navigate("/invalid-link");
        } else {
          // Fallback for other errors, originally navigated to invalid-link
          navigate("/invalid-link");
        }
      });
    } else {
      navigate("/invalid-link");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const EnableHandler = () => {
    if (stateName.firstPassword !== stateName.secondPassword) {
      return;
    }
    {
      setIsLoading(true);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const token = urlSearchParams.get("q");
      console.log(token);
      const CreateUserByLink = dispatch(
        CreateUserByLinkApi({
          id: token,
          requestHeaders: {
            full_name: stateName.fullName,
            email: stateName.email,
            timezone: userTimeZone,
            password: stateName.firstPassword,
          },
        })
      );
      CreateUserByLink.then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
        }
        else if (data?.payload?.status === 200) {
          toast.success("User successfully joined");
          navigate("/");
        } else if (data?.payload?.status === 400) {
          toast.error(data?.payload?.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
        }
      }).catch(async (error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setIsLoading(false);
      });
    }
  };
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage]
  );

  if (isValidating) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <>
      <Navbar />
      <div className="SignUp-main-container">
        <div className="inputDivStyle-signup">
          <div className="textDiv">
            <p className="text__create">{t.CREATE_ACCOUNT}</p>
            <p className="text__start">{t.FREE_TRIAL_MSG}</p>
          </div>

          <Input
            type="text"
            id="fullName"
            name="fullName"
            title={t.TITLE_FULL_NAME}
            placeholder={t.PLACEHOLDER_FULL_NAME}
            value={stateName.fullName}
            onChange={(e) => handleChange(e)}
            error={stateName.fullNameInvalidMessage}
            className={clsx(
              stateName.fullNameInvalid ? "input__error" : " ",
              stateName.nameState ? "input__success" : " "
            )}
          />
          <br />
          <Input
            type="email"
            id="email"
            name="email"
            title={t.TITLE_EMAIL}
            placeholder={t.ENTR_EML_PH}
            value={stateName.email}
            onChange={(e) => handleChange(e)}
            error={stateName.emailInvalidMessage}
            className={clsx(
              stateName.emailInvalidMessage ? "input__error" : "",
              stateName.emailState ? "input__success" : " "
            )}
          />
          <br />
          <div>
            <PasswordField
              name="firstPassword"
              id="firstPassword"
              type="Password"
              title={t.ENTR_PWD}
              placeholder={t.ENTR_PASS_PH}
              value={stateName.firstPassword}
              onChange={(e) => handleChangePassword(e)}
              error={stateName.firstPasswordInvalidError}
              className={clsx(
                stateName.firstPasswordInvalid ? "input__error" : "",
                stateName.firstPasswordState ? "input__success" : ""
              )}
            />
            <br />
            <PasswordField
              name="secondPassword"
              id="secondPassword"
              type="password"
              title={t.ENTR_PWD_C}
              placeholder={t.REENTR_PASS_PH}
              value={stateName.secondPassword}
              onChange={(e) => handleChangePassword(e)}
              error={stateName.secondPasswordInvalidError}
              className={clsx(
                stateName.secondPasswordInvalid ? "input__error" : " ",
                stateName.secondPasswordState ? "input__success" : " "
              )}
            />
          </div>
          <div className="btn-class">
            <ButtonMain
              title={isLoading ? t.BTN_LOADING : t.BTN_CONTINUE}
              disabled={
                isLoading ||
                !(
                  stateName.nameState &&
                  stateName.emailState &&
                  stateName.firstPasswordState &&
                  stateName.secondPasswordState &&
                  stateName.firstPassword === stateName.secondPassword
                )
              }
              className={
                stateName.nameState &&
                  stateName.emailState &&
                  stateName.firstPasswordState &&
                  stateName.secondPasswordState &&
                  stateName.firstPassword === stateName.secondPassword &&
                  !isLoading
                  ? "buttonStyleEnable"
                  : "buttonStyleDisabled"
              }
              onClick={() => EnableHandler()}
            />
          </div>
        </div>
      </div>
      <FooterTrustChat />
    </>
  );
}

export default CreateUserFromInviteLink;
